import { render } from "./ProdutoEdit.vue?vue&type=template&id=71a944b6&scoped=true"
import script from "./ProdutoEdit.vue?vue&type=script&lang=js"
export * from "./ProdutoEdit.vue?vue&type=script&lang=js"

import "./ProdutoEdit.vue?vue&type=style&index=0&id=71a944b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71a944b6"

export default script